exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".main-container {\n    padding: 0;\n}\n\n.card {\n    border-radius: 0;\n    border: none;\n}\n\n.summary-item {\n    margin-bottom: 10px;\n}\n\n#step-container {\n    min-height: 470px;\n    padding: 12px 20px;\n}\n\nbutton {\n    cursor: pointer;\n}\n\n\n@media (min-width: 576px) {\n    body {\n        padding-top: 15px;\n    }\n\n    .main-container {\n        padding-left: 15px;\n        padding-right: 15px;\n    }\n\n    .card {\n        border-radius: 4px;\n        border: 1px solid rgba(0, 0, 0, 0.125);\n    }\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./src/styles/styles.css
// module id = 160
// module chunks = 0